import { useReducedMotion as useMotionReducedMotion } from 'motion/react';
import { useHydrated } from '@/hooks/useHydrated';

/**
 * motion's useReducedMotion, read only after hydration. The build has no
 * prefers-reduced-motion, so the hydration pass renders the motion variant the
 * prerender did, and reduced-motion visitors switch right after mount (motion's
 * own reducedMotion="user" in App already skips the animations themselves).
 */
export function useReducedMotion(): boolean {
  const reduced = useMotionReducedMotion();
  return useHydrated() && reduced === true;
}
